import { oz } from '@weft/utils';
import { EnumEventFieldSchema } from './enum-event-field-schema';
import { NumberEventFieldSchema } from './number-event-field-schema';
import { StringEventFieldSchema } from './string-event-field-schema';

export const EventFieldSchema = oz.discriminatedUnion('type', [
  NumberEventFieldSchema,
  StringEventFieldSchema,
  EnumEventFieldSchema,
]).openapi('EventField');

export type EventField = oz.infer<typeof EventFieldSchema>;